import React from 'react';
import './WhySection.css';

const features = [
  {
    icon: 'fas fa-tasks',
    title: 'Продвинутый сбор данных',
    description: 'Прозрачная методология и регламенты сбора данных, гарантируют сопоставимую и качественную статистику о компенсациях и льготах.',
  },
  {
    icon: 'fas fa-check-double',
    title: 'Многоуровневая валидация',
    description: 'Перекрестная проверка в нескольких источниках, проверка на «аномалии» с помощью AI, доработка вручную, опираясь на отраслевой опыт и знания.',
  },
  {
    icon: 'fas fa-shield-alt',
    title: 'Надёжная защита и конфиденциальность',
    description: 'Строгие протоколы шифрования и система уровневого доступа гарантируют сохранность данных на платформе.',
  },
  {
    icon: 'fas fa-brain',
    title: 'Предиктивные модели на базе AI',
    description: 'Мы используем машинное обучение и языковые модели, чтобы прогнозировать тренды компенсаций и заранее демонстрировать нашим Клиентам, как может измениться рынок.',
  },
  {
    icon: 'fas fa-random',
    title: 'Сценарное моделирование',
    description: 'Наша команда и инструменты платформы помогут смоделировать разные варианты структуры вознаграждения и оценить, как изменения в бонусах или опционном пакете отразятся на конкурентоспособности и бюджете.',
  },
  {
    icon: 'fas fa-file-alt',
    title: 'Бенчмаркинг и индивидуальные отчеты',
    description: 'Помимо классических дашбордов наша команда поможет сформировать кастомизированные отчёты и проведет индивидуальную консультацию.',
  },
];

const WhySection: React.FC = () => (
  <section className="why-section">
    <div className="why-label">ПОЧЕМУ DATACIRCLE</div>
    <h2 className="why-title">
      Мы <span className="why-gradient">получаем</span> нужную информацию там, где другие<br />даже не пытаются ее найти
    </h2>
    <p className="why-description">
      Каждый клиентский кейс уникален: мы выстраиваем стратегию поиска данных под уникальный запрос, используем экспертизу нашей команды отраслевых экспертов и аналитиков, AI-инструменты, а затем оформляем всё в удобные дашборды и отчёты.
    </p>
    <div className="features-grid">
      {features.map((f, i) => (
        <div className="feature-box" key={i}>
          <div className="ai-badge">AI</div>
          <div className="feature-icon">
            <i className={f.icon}></i>
          </div>
          <h3 className="feature-title">{f.title}</h3>
          <p className="feature-description">{f.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default WhySection; 